<script>
import { mapActions, mapGetters } from "vuex";
import filterComp from "./components/filter";
import tableComp from "./components/table";
import {
  qtManageScopeFromPath,
  qtManageConfig,
  CLIENT_VERSION_LIMIT_MESSAGE,
  isClientVersionQuotaFull,
} from "@/utils/clientPlatforms";

export default {
  data() {
    return {
      toolbarOperations: [
        {
          text: "上传",
          key: "add",
        },
        {
          text: "启用",
          key: "start",
        },
        {
          text: "停用",
          key: "stop",
        },
        {
          text: "删除",
          key: "delete",
        },
      ],
      pageInfo: {
        page_num: 1,
        page_size: 8
      },
      oldParams: {},
      checkDatas: []
    };
  },
  components: {
    filterComp,
    tableComp,
  },
  computed: {
    ...mapGetters(["qtListTotal"]),
    manageCfg() {
      return qtManageConfig(qtManageScopeFromPath(this.$route.path));
    },
  },
  mounted() {
    this.toolbarOperations[0].text = this.manageCfg.toolbarAdd;
    this.getList();
  },
  watch: {
    "$route.path"() {
      this.toolbarOperations[0].text = this.manageCfg.toolbarAdd;
      this.getList(null, true);
    },
  },
  methods: {
    ...mapActions([
      "getQtList",
      "deleteQtData",
      "updateQtStatus"
    ]),
    async getList(params, isFirstPage) {
      if (isFirstPage) {
        this.pageInfo.page_num = 1;
      }
      const filterVal = this.$refs.filter ? this.$refs.filter.getValue() : {};
      let queryParams = {
        ...this.oldParams,
        ...filterVal,
        ...this.pageInfo
      };
      queryParams._versionApi = this.manageCfg.versionApi;
      if (this.manageCfg.fixedChannel) {
        if (this.manageCfg.scope === "desktop") {
          queryParams.channel = this.manageCfg.fixedChannel;
        }
        delete queryParams.channel_in;
      } else if (this.manageCfg.scope === "desktop" && !queryParams.channel) {
        queryParams.channel_in = this.manageCfg.allowedChannels;
        delete queryParams.channel;
      } else {
        delete queryParams.channel_in;
      }
      if (params) {
        Object.keys(this.pageInfo).forEach((key) => {
          if (params.hasOwnProperty(key)) {
            this.pageInfo[key] = params[key];
          }
        })
        queryParams = {
          ...queryParams,
          ...params
        };
      }
      try {
        this.$changeLoadingState(true);
        await this.getQtList(queryParams);
        this.checkDatas = [];
      } catch (error) {
        console.log(error);
      }
      this.$changeLoadingState(false);
      this.oldParams = queryParams;
    },
    operationHandler(key) {
      switch (key) {
        case 'add':
          if (isClientVersionQuotaFull(this.qtListTotal)) {
            this.$message.warning(CLIENT_VERSION_LIMIT_MESSAGE);
            return;
          }
          this.$router.push(this.manageCfg.addPath);
          break;
        case 'delete':
          this.batchDelete();
          break;
        case 'start':
        case 'stop':
          this.batchUpdateStatus(key === 'start' ? 'true' : 'false');
          break;
        default:
          break;
      }
    },
    async batchDelete() {
      if (this.checkDatas.length === 0) {
        this.$message.error('请先勾选要删除的数据');
        return;
      }
      try {
        await this.$confirm(
          this.$tt('删除后，安装包记录及服务器上的源文件将一并删除且无法恢复，是否继续？'),
          this.$tt('删除确认'),
          { type: 'warning' }
        );
      } catch (e) {
        return;
      }
      const ids = this.checkDatas.reduce((arr, item) => {
        arr.push(item.id);
        return arr;
      }, []);
      try {
        this.$changeLoadingState(true);
        await this.deleteQtData({ ids: ids, _versionApi: this.manageCfg.versionApi });
        this.$changeLoadingState(false);
        this.getList();
      } catch (error) {
        console.log(error);
        this.$changeLoadingState(false);
      }
    },
    async batchUpdateStatus(status) {
      if (this.checkDatas.length === 0) {
        this.$message.error('请先勾选要操作的数据');
        return;
      }
      const ids = this.checkDatas.reduce((arr, item) => {
        arr.push(item.id);
        return arr;
      }, []);
      try {
        this.$changeLoadingState(true);
        await this.updateQtStatus({ ids: ids, status, _versionApi: this.manageCfg.versionApi });
        this.$changeLoadingState(false);
        this.getList();
      } catch (error) {
        console.log(error);
        this.$changeLoadingState(false);
      }
    },
    search() {
      this.getList(null, true);
    },
    selectChange(val) {
      this.checkDatas = val;
    }
  },
};
</script>
<template>
  <div class="main-container">
    <filter-comp
      ref="filter"
      :fixed-channel="manageCfg.fixedChannel"
      :allowed-channels="manageCfg.allowedChannels"
      @search="search"
    />
    <div class="toolbarOperations">
      <el-button
        size="mini"
        v-for="t in toolbarOperations"
        :key="t.key"
        :type="t.key == 'delete' ? 'danger' : 'primary'"
        @click="operationHandler(t.key)"
        >{{ t.text }}</el-button
      >
    </div>
    <table-comp
      :pageNum="pageInfo.page_num"
      :edit-path="manageCfg.editPath"
      :version-api="manageCfg.versionApi"
      :show-channel="manageCfg.scope === 'desktop'"
      :list-labels="manageCfg.listLabels"
      @selectChange="selectChange"
      @getDatas="getList"
    ></table-comp>
  </div>
</template>
<style lang="scss" scoped>
.main-container {
  height: 100%;
  background: #fff;
  padding: 10px;
}
</style>
<style lang="scss">
.toolbarOperations {
  margin-bottom: 16px;
//   .el-button {
//     padding: 10px 12px;
//   }
}
</style>
